export default __webpack_public_path__ + "static/media/thumb1.85bcecb7.jpg";